import React, { useContext } from 'react';

import BonusProgramPeriodsProvider from 'contextProviders/BonusProgramPeriodsProvider';
import Button from 'kingpin/atoms/Button';
import usePopup from 'hooks/usePopup';

import BonusOverviewProvider, {
  BonusOverviewContext,
} from '../../providers/BonusOverviewProvider';
import { HOME_PROGRAM_SLUG } from '../BonusAppEmbed';
import ViewDriverAppModal from './ViewDriverAppModal';

const HomeButton = () => {
  const { bonusOverview } = useContext(BonusOverviewContext);
  const { isOpen, open, close } = usePopup();

  return (
    <>
      <Button
        size={'Medium'}
        type={'Secondary'}
        label={'View Driver App'}
        onClick={open}
        isDisabled={!bonusOverview}
      />
      <ViewDriverAppModal
        isOpen={isOpen}
        close={close}
        programSlug={HOME_PROGRAM_SLUG}
      />
    </>
  );
};

/**
 * The combined bonus tab's single "View Driver App" entry: opens the embed on
 * its home screen (which lists every program). The embed still requires a
 * bootstrap bonusDocument to learn the driver + year, so we mount a bonus
 * overview provider for one of the driver's programs and inject that program's
 * document — exactly as the per-program entries do — while telling the embed to
 * land on home via HOME_PROGRAM_SLUG. The button stays disabled until that
 * bootstrap document has loaded.
 */
const ViewHomeDriverAppButton = ({
  driver,
  bootstrapProgram,
}: {
  driver: string;
  bootstrapProgram: BonusTypes.BonusProgram;
}) => (
  <BonusProgramPeriodsProvider programId={bootstrapProgram.id}>
    <BonusOverviewProvider
      bonusProgramId={bootstrapProgram.id}
      driver={driver}
      variant={'overview'}
    >
      <HomeButton />
    </BonusOverviewProvider>
  </BonusProgramPeriodsProvider>
);

export default ViewHomeDriverAppButton;
